import axios from "../utils/axiosConfig";

const roleService = {
    getAll: async () => {
        try {
            const response = await axios.get("/roles");
            return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },
    
    getById: async (id) => {
        try {
          const response = await axios.get(`/roles/${id}`);
          return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },
};

export default roleService;